var React = require('react');

function Nl (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#ae1c28","d":"M0 0h640v160H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 160h640v160H0z","key":1}),React.createElement("path",{"fill":"#21468b","d":"M0 320h640v160H0z","key":2})]);
}

Nl.defaultProps = {"id":"flag-icons-nl","viewBox":"0 0 640 480"};

module.exports = Nl;

Nl.default = Nl;
